// extracted by mini-css-extract-plugin
export var deleteIcon = "_oa-5";
export var deleteOption = "_oa-3";
export var divider = "_oa-2";
export var downloadIcon = "_oa-4";
export var drawer = "_oa-0";
export var drawerFooter = "_oa-6";
export var drawerOpen = "_oa-1";
export var highlighted = "_oa-7";
export var lighterHighlight = "_oa-8";